var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRugby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 1.12 1.119 40C.426 36.405.018 32.256 0 28.017V28A67.4 67.4 0 0 1 4.476 3.857l-.156.462C11.352 1.595 19.488.01 27.996-.001h.006c4.254.018 8.403.426 12.423 1.188l-.423-.066zM94.92 56.004 56.001 94.92c3.603.678 7.752 1.072 11.991 1.08h.009a67.4 67.4 0 0 0 24.144-4.476l-.462.156c2.724-7.031 4.308-15.168 4.32-23.675v-.007a69 69 0 0 0-1.146-12.422l.066.422zM92.001 45.04 45.042 92C25.869 84.983 11.019 70.132 4.155 51.43l-.153-.47L50.961 4c19.173 7.018 34.023 21.868 40.887 40.57zm-22.722 4.4a4 4 0 0 0-2.88-1.224 4 4 0 0 0-2.88 1.224l-2.76 2.76-5.601-5.559 2.799-2.799a4.142 4.142 0 1 0-5.958-5.76l-2.802 2.803-5.199-5.602 2.76-2.76a4.06 4.06 0 0 0-5.718-5.76l-14.28 14.08a4.06 4.06 0 0 0 5.76 5.718l2.76-2.56 5.601 5.56-2.76 2.799a4.033 4.033 0 0 0 5.877 5.523l.003-.004 2.799-2.76 5.559 5.602-2.76 2.76a4.06 4.06 0 0 0 5.718 5.76l14.079-14.08a4 4 0 0 0 1.125-2.78 4 4 0 0 0-1.284-2.937l-.003-.004z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRugby);
export default __webpack_public_path__ + "static/media/rugby.ae24e9062ad4826fd97ddd1b37e92006.svg";
export { ForwardRef as ReactComponent };